import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { CONTACTS } from "@/data/content";

export default function Footer() {
  return (
    <footer
      className="mt-24 pt-16 pb-8 grain"
      style={{
        backgroundColor: "#08070A",
        color: "var(--text-secondary)",
        borderTop: "1px solid var(--border-gold)",
      }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <h3 className="text-2xl mb-3 gold-text">Spazzacamino Davide</h3>
          <p className="text-sm max-w-md" style={{ color: "var(--text-secondary)" }}>
            Servizio professionale di spazzacamino qualificato ANFUS. Oltre vent'anni
            di esperienza nella pulizia di canne fumarie, stufe, camini e caldaie in
            tutta l'Emilia.
          </p>
          <div className="mt-5 flex gap-3 flex-wrap">
            <a
              href={`tel:${CONTACTS.phoneRaw}`}
              className="btn-primary"
              data-testid="footer-call-btn"
            >
              <Phone size={16} /> {CONTACTS.phoneDisplay}
            </a>
            <a
              href={`https://wa.me/${CONTACTS.whatsapp}?text=${encodeURIComponent(CONTACTS.whatsappMsg)}`}
              target="_blank"
              rel="noreferrer"
              className="btn-whatsapp"
              data-testid="footer-whatsapp-btn"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-lg mb-3" style={{ color: "var(--gold-bright)" }}>Zone servite</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/spazzacamino/modena" className="hover:text-[var(--gold-bright)] transition-colors">Spazzacamino Modena</Link></li>
            <li><Link to="/spazzacamino/bologna" className="hover:text-[var(--gold-bright)] transition-colors">Spazzacamino Bologna</Link></li>
            <li><Link to="/spazzacamino/reggio-emilia" className="hover:text-[var(--gold-bright)] transition-colors">Spazzacamino Reggio Emilia</Link></li>
            <li><Link to="/fotovoltaico" className="hover:text-[var(--gold-bright)] transition-colors">Pulizia fotovoltaico</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-lg mb-3" style={{ color: "var(--gold-bright)" }}>Contatti</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-0.5 flex-shrink-0" />
              <a href={`tel:${CONTACTS.phoneRaw}`}>{CONTACTS.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-0.5 flex-shrink-0" />
              <a href={`mailto:${CONTACTS.email}`} className="break-all">{CONTACTS.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 flex-shrink-0" />
              <span>Modena, Bologna, Reggio Emilia e province</span>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="max-w-7xl mx-auto px-5 md:px-8 mt-12 pt-6 text-xs opacity-70 flex flex-col md:flex-row justify-between gap-2"
        style={{ borderTop: "1px solid rgba(232,223,211,0.15)" }}
      >
        <span>© {new Date().getFullYear()} Spazzacamino Davide — Tutti i diritti riservati</span>
        <span>Spazzacamino Qualificato Associato ANFUS</span>
      </div>
    </footer>
  );
}
